import { Pipe, PipeTransform } from '@angular/core';
import { AppConst } from '../../app-const';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'typeOfMap',
  standalone: false,
})
export class TypeOfMapPipe implements PipeTransform {

  constructor(private translate: TranslateService) { }

  transform(value: string): any {
    let type: string = '';

    switch (value) {
      case AppConst.MAP_DISP_TYPE_MAP:
        type = this.translate.instant('地図タイプ');
        break;
      case AppConst.MAP_DISP_TYPE_SATELLITE:
        type = this.translate.instant('航空写真タイプ');
        break;
    }
    return type;
  }

}
